import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import api, {standardApiSlice} from 'service/api'

export const resetPassword = createAsyncThunk('login/resetPassword', api.post('/password/reset'))

export const resetPasswordSlice = createSlice(standardApiSlice('resetPassword', resetPassword))

export const { clearErrors } = resetPasswordSlice.actions

export default resetPasswordSlice.reducer